// extracted by mini-css-extract-plugin
module.exports = {"tabs":"TabWidget_tabs__3T7gA","emptyTab":"TabWidget_emptyTab__dQBL3","widget":"TabWidget_widget__1ACqt"};